// /src/store/settingsStore.js
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useSettingsStore = create(
  persist(
    (set) => ({
      // defaults
      lang: 'en',
      theme: 'light',
      notifications: 'on',
      privacy: 'off',
      soundsEnabled: true,

      // actions
      setLang: (lang) => set({ lang }),
      toggleLang: () =>
        set((s) => ({ lang: s.lang === 'en' ? 'fr' : 'en' })),

      setTheme: (theme) => set({ theme }),
      toggleTheme: () =>
        set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' })),

      setNotifications: (notifications) => set({ notifications }),
      setPrivacy: (privacy) => set({ privacy }),
      setSoundsEnabled: (enabled) => set({ soundsEnabled: enabled }),
    }),
    {
      name: 'app-settings',             // key in localStorage
      getStorage: () => localStorage,   // (default)
    }
  )
)